// import { useEffect, useState } from "react";
// import { useNavigate, useLocation } from "react-router-dom";
// import Cookies from 'js-cookie';

// declare global {
//   interface Window {
//     fbq: (...args: any[]) => void;
//   }
// }

const Install2 = () => {

    return <h2>Redirecting...</h2>;
};

export default Install2;
